/*
 * TecHub embedded Arabic theme-content translations.
 * Applies only to Arabic storefront requests. Store content (products, collections,
 * pages, media alt text, policies) remains managed through Shopify's translation system.
 */
(function () {
  'use strict';

  var entries = window.TecHubARThemeContentTranslations || [];
  if (!entries.length) return;

  var main = document.getElementById('MainContent');
  var activeTemplate = main && main.getAttribute('data-template')
    ? main.getAttribute('data-template').replace(/\.json$/, '')
    : '';

  var byTemplateAndSection = Object.create(null);
  entries.forEach(function (entry) {
    var key = entry.template + '::' + entry.sectionId;
    if (!byTemplateAndSection[key]) byTemplateAndSection[key] = [];
    byTemplateAndSection[key].push(entry);
  });

  function normalizeText(value) {
    var normalized = String(value == null ? '' : value)
      .replace(/\u00a0/g, ' ')
      .replace(/[\u200e\u200f\u202a-\u202e]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    return typeof normalized.normalize === 'function' ? normalized.normalize('NFKC') : normalized;
  }

  function normalizedHTML(value) {
    var template = document.createElement('template');
    template.innerHTML = String(value || '');
    return template.innerHTML
      .replace(/>\s+</g, '><')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function htmlText(value) {
    var template = document.createElement('template');
    template.innerHTML = String(value || '');
    return normalizeText(template.content.textContent || '');
  }

  function safeHTML(value) {
    var template = document.createElement('template');
    // Shopify's translated rich-text values can occasionally arrive with paragraph
    // tags double-escaped. Decode only p tags so they render as markup, not visible text.
    var markup = String(value || '').replace(/&lt;(\/?)\s*p\s*\/?&gt;/gi, function (_, closing) {
      return closing ? '</p>' : '<p>';
    });
    template.innerHTML = markup;
    template.content.querySelectorAll('script, style, iframe, object, embed, form').forEach(function (node) {
      node.remove();
    });
    template.content.querySelectorAll('*').forEach(function (node) {
      Array.prototype.slice.call(node.attributes).forEach(function (attribute) {
        var name = attribute.name.toLowerCase();
        var val = String(attribute.value || '').trim().toLowerCase();
        if (name.indexOf('on') === 0) node.removeAttribute(attribute.name);
        if ((name === 'href' || name === 'src' || name === 'xlink:href') && val.indexOf('javascript:') === 0) {
          node.removeAttribute(attribute.name);
        }
      });
    });
    return template.innerHTML;
  }

  function isHTML(value) {
    return /<\/?[a-z][\s\S]*?>/i.test(String(value || ''));
  }

  function translateHTML(root, source, translated) {
    var wanted = normalizedHTML(source);
    var candidates = root.querySelectorAll('*');
    for (var i = 0; i < candidates.length; i += 1) {
      var element = candidates[i];
      if (/^(SCRIPT|STYLE|SVG|PATH|NOSCRIPT)$/.test(element.tagName)) continue;
      if (normalizedHTML(element.innerHTML) === wanted) {
        element.innerHTML = safeHTML(translated);
        return true;
      }
    }

    // Formatting differences can occur when rich text is normalized by Shopify.
    // Fall back only when a single element contains exactly the original text.
    var wantedText = htmlText(source);
    if (!wantedText) return false;
    var textMatches = [];
    for (var j = 0; j < candidates.length; j += 1) {
      var candidate = candidates[j];
      if (/^(SCRIPT|STYLE|SVG|PATH|NOSCRIPT)$/.test(candidate.tagName)) continue;
      if (normalizeText(candidate.textContent) === wantedText) textMatches.push(candidate);
    }
    if (!textMatches.length) return false;

    // Choose the outermost exact-text container inside the section so translated
    // rich text keeps its intended paragraph/heading markup and surrounding section.
    var chosen = textMatches[0];
    for (var k = 1; k < textMatches.length; k += 1) {
      if (textMatches[k].contains(chosen)) chosen = textMatches[k];
    }
    chosen.innerHTML = safeHTML(translated);
    return true;
  }

  function translatePlainText(root, source, translated) {
    var wanted = normalizeText(source);
    var changed = false;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !normalizeText(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (node.parentElement && /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT)$/i.test(node.parentElement.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      if (normalizeText(node.nodeValue) === wanted) {
        node.nodeValue = translated;
        changed = true;
      }
    });

    var attributeNames = ['alt', 'aria-label', 'title', 'placeholder', 'value'];
    var elements = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    elements.forEach(function (element) {
      attributeNames.forEach(function (name) {
        if (element.hasAttribute && element.hasAttribute(name) && normalizeText(element.getAttribute(name)) === wanted) {
          element.setAttribute(name, translated);
          changed = true;
        }
      });
    });
    return changed;
  }

  function sectionIdFromElement(element) {
    if (!element || !element.id) return '';
    var delimiter = element.id.lastIndexOf('__');
    return delimiter >= 0 ? element.id.slice(delimiter + 2) : '';
  }

  function applySection(section) {
    if (!section || !section.id || section.id.indexOf('shopify-section-') !== 0) return;
    var sectionId = sectionIdFromElement(section);
    if (!sectionId) return;

    var globalKeyHeader = 'sections/header-group::' + sectionId;
    var globalKeyFooter = 'sections/footer-group::' + sectionId;
    var templateKey = activeTemplate + '::' + sectionId;
    var scopedEntries = byTemplateAndSection[templateKey] ||
      byTemplateAndSection[globalKeyHeader] ||
      byTemplateAndSection[globalKeyFooter];
    if (!scopedEntries) return;

    scopedEntries.forEach(function (entry) {
      if (!entry.source || !entry.translation || entry.source === entry.translation) return;
      if (entry.source.indexOf('{{') !== -1 || entry.source.indexOf('{%') !== -1) return;
      if (isHTML(entry.source)) translateHTML(section, entry.source, entry.translation);
      else translatePlainText(section, entry.source, entry.translation);
    });
  }

  function cleanLiteralParagraphTags(root) {
    if (!root || !root.querySelectorAll) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SVG|CODE|PRE)$/i.test(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      if (!node.nodeValue) return;
      var cleaned = node.nodeValue.replace(/(?:&lt;|&#0*60;|<)\s*\/?\s*p\s*\/?\s*(?:&gt;|&#0*62;|>)/gi, '');
      if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
    });
  }

  function applyAll() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(applySection);
    var mainContent = document.getElementById('MainContent');
    if (mainContent) cleanLiteralParagraphTags(mainContent);
  }

  function applyWithin(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('[id^="shopify-section-"]')) applySection(node);
    var parent = node.closest && node.closest('[id^="shopify-section-"]');
    if (parent && parent !== node) applySection(parent);
    if (node.querySelectorAll) node.querySelectorAll('[id^="shopify-section-"]').forEach(applySection);
    var mainContent = node.closest && node.closest('#MainContent');
    if (mainContent) cleanLiteralParagraphTags(mainContent);
    else if (node.id === 'MainContent' || (node.querySelector && node.querySelector('#MainContent'))) {
      cleanLiteralParagraphTags(node.id === 'MainContent' ? node : node.querySelector('#MainContent'));
    } else {
      var sectionRoot = node.closest && node.closest('[id^="shopify-section-"]');
      if (sectionRoot) cleanLiteralParagraphTags(sectionRoot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    applyWithin(event.target);
  });

  if (window.MutationObserver && document.documentElement) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(applyWithin);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
